import React, { useState } from "react";
import ReactPlayer from 'react-player';
import { Fragment } from "react"

function FAQ({title, message}) {

    const [showMessage, setShowMessage] = useState(false)

    function handleOpen() {
        setShowMessage(!showMessage)
    }

    return (
        <div className={`text-format pt-3 me-md-5 ${showMessage ? 'bg-light-gray py-3 mb-2' : ''}`} style={{"fontSize": "1rem"}}>
            <div className="d-flex text-form-title me-2 ps-3" role="button" onClick={handleOpen}>
                {showMessage ?
                    <span className="ms-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M5.8 9H12.2M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z" stroke="#BCBCBC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </span>
                    :
                    <span className="ms-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M9 5.8V12.2M5.8 9H12.2M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z" stroke="#BCBCBC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </span>
                }

                <p style={{color : "#212121"}}> {title}</p>
            </div>

            {showMessage &&<p className="ps-4 me-4" style={{"textAlign": "justify",color:"#7A7A7A",fontSize:"0.82rem"}}>{message}</p>}
        </div>
    );
}

export default function Learning() {

    const space = <span>&hairsp;</span>

    const learningList = [
        {
            title: "سامانه مودیان مالیاتی چیست ؟",
            message: <>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می<span>&#8202;</span>طلبد،</>
        },
        {
            title: " مفهوم CSR چیست ؟",
            message: <>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می<span>&#8202;</span>طلبد،</>
        },
        {
            title: "کلید عمومی و خصوصی به چه معناست ؟",
            message: <>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می<span>&#8202;</span>طلبد،</>
        },
        {
            title: " گواهی امضای دیجیتال چیست ؟",
            message: <>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می<span>&#8202;</span>طلبد،</>
        }
    ]

    const FaqList = [
        {
            title: "نحوه تولید CSR و صدور گواهی در سامانه به چه ترتیب است؟",
            message: "بعد از احراز هويت شما در سامانه، فرآیند تولید کلید، تولید CSR و صدور گواهی به صورت خودکار انجام خواهد شد و نهایتا کلیدعمومي و خصوصي و همچنین فایل گواهی از سامانه قابل بارگيري (دانلود) هستند."
        },
        {
            title: "در صورت مفقود شدن کلید چه کنیم ؟",
            message: "از آنجا که این کلیدها به یک گواهی منتسب شده‌اند و آن گواهي حكم هويت ديجيتال ما را خواهد داشت، لازم است که با مرکز صادرکننده گواهی تماس گرفته و درخواست ابطال گواهی مفقود شده را بدهید تا از سوءاستفاده های آتی از کلید خصوصی شما جلوگیری شود از طرفی لازم است که مجددا به سامانه صدور گواهي موديان مالياتي مراجعه كرده و با طي كردن مراحل احراز هويت، گواهي و كليدهاي جديد را دريافت كنيم."
        },
        {
            title: "آیا میتوان از کلیدهای خودمان که از جایی دیگر گرفتیم استفاده کنیم ؟",
            message: "بله، در صورتی که قبلا به روش‌هاي امن، اقدام به تولید کلید کرده‌ باشيد، پس از انجام احراز هويت در سامانه، مي‌توانيد كليدهاي خود را بارگذاري كرده و ادامه‌ي فرآيند و صدور گواهي به صورت خودكار انجام خواهد شد و گواهی منتسب به کلید های شما صادر می‌شود."
        },
        {
            title: "مدت اعتبار گواهی چه مدت است ؟",
            message: "اين گواهي يك سال اعتبار خواهد داشت و قبل از انقضاي آن لازم است كه براي تمديد گواهي اقدام كنيد."
        },
        {
            title: "هزینه دریافت گواهی چقدر است ؟",
            message: " هزينه‌ دريافت گواهي 350 هزار تومان مي‌باشد كه شامل هزينه‌ي صدور گواهي مطابق با نرخ مصوب مركز ريشه‌ي وزارت صنعت معدن تجارت به علاوه هزينه‌ي سرويس‌هاي استعلامي و احراز هويت تصويري مي‌باشد."
        },
        {
            title: "کلیدها به چه صورت تحویل داده خواهد شد ؟",
            message: "در مرحله تولید کلید به صورت فايل بدون رمز قابل دريافت است."
        },
        {
            title: "فایل گواهی چگونه دریافت می‌شود ؟",
            message: "پس از طي كردن مراحل احراز هويت در سامانه صدور گواهي شركت هويتا، فايل گواهي، كليد عمومي و كليد خصوصي به صورت فايل قابل بارگيري (دانلود) هستند."
        },
        {
            title: "احراز هویت به چه صورت انجام می‌شود ؟",
            message: "احراز هويت به صورت غيرحضوري و با استفاده از خدمات ثبت احوال، شاهكار و هوش مصنوعي (تصویری) خواهد بود كه زنده بودن و هويت شما را تاييد خواهد كرد."
        },
    ]

    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlay = () => {
        setIsPlaying(true);
    };

    const handlePause = () => {
        setIsPlaying(false);
    };

    const videoStyle = {}

    return(
        <div className=" p-3 p-md-5">
            <div className="mt-4">
                <p className="text-form-title learning-title">سامانه مودیان مالیاتی چیست ؟</p>
                <p className="text-format" style={{"fontSize": "1rem", "textAlign": "justify", lineHeight: "2rem"}}>سامانه مودیان یک سامانه ثبت نام و گزارش درآمد برای اشخاص حقوقی و حقیقی است که باید در صورت داشتن درآمدی از هر نوعی به جزء درآمد، در این سامانه ثبت نام کنند. به عبارت دیگر، اشخاصی که درآمدی از فروش کالا یا خدمات، اجاره ملک، درآمد حرفه‌ای، درآمد از بورس و سهم، درآمد از فعالیت‌های اینترنتی و غیره دارند، می‌توانند در این سامانه ثبت نام کنند.</p>
            </div>
            <div className="player-wrapper">
                {/*<ReactPlayer*/}
                {/*    url="client/Moadian.mp4"*/}
                {/*    width="640"*/}
                {/*    height="360"*/}
                {/*    id="video-player"*/}
                {/*    controls={isPlaying}*/}
                {/*    onPlay={handlePlay}*/}
                {/*    playing={isPlaying}*/}
                {/*    style={isPlaying ? {} : videoStyle}*/}
                {/*/>*/}

                <video style={{width: "100%"}} controls>
                    <source src="film/Moadian.mp4" type="video/mp4" />
                </video>

                {/*{!isPlaying && <div className="play-button-overlay">*/}
                {/*    <button className="custom-play-button"  onClick={handlePlay}>*/}
                {/*        <img src={require('./../../image/play.png')} className="custom-play-button-img"/>*/}
                {/*    </button>*/}
                {/*</div>}*/}

            </div>

            <div className="mt-5 pt-5">
                <p className="text-form-title learning-title"> سوالات متداول </p>
                {
                    FaqList.map((item, index) => (
                        <FAQ key={index} title={item.title} message={item.message}/>
                    ))
                }

            </div>
        </div>
    )
}
